import Modifier from "../Modifier";
import DatePeriod from "../DatePeriod";

class InterpolateConstantModifier extends Modifier {

    constructor(parameters) {
        super(parameters);
        this.name = 'interpolate_constant';
    }

    compute(data, periodicity) {
        // produce lag free data
        let newData = this.lagFreeData(data, periodicity);

        let gap = [];
        let pre = null;
        let inters = [];
        let that = this;

        _.forEach(newData, function (val, time) {

            // we have encountered a gap
            if (val === null) {
                gap.push(time);
                return; // nothing more to do
            }

            // first case: we are possibly the last value before a gap
            if (gap.length === 0) {
                pre = val;
                return;
            }

            // second case: we are at the end of a gap!
            inters.push(that.interpolate(pre, gap));

            pre = val;
            gap = [];
        });

        _.forEach(inters, function (item) {
            _.forEach(item, function (val, time) {
                newData[time] = val;
            })
        });

        // reindex all the crap
        let result = [];

        // convert it back to internal format
        _.forEach(newData, function (val, time) {
            result.push({
                time: time,
                value: val,
            });
        });

        return result;
    }

    lagFreeData(data, periodicity) {

        const dates = DatePeriod.range(data[0].time + '-01', data[data.length - 1].time + '-01', periodicity);

        // index dates
        let newResult = {};
        dates.forEach(function (time) {
            newResult[time] = null;
        });

        // index data by time.
        data.forEach(function (point) {
            newResult[point.time] = point.value;
        });

        return newResult;
    }

    interpolate(pre, missing) {
        let result = {};

        _.forEach(missing, function (time) {
            result[time] = pre;
        });

        return result;
    }
}

export default InterpolateConstantModifier;
